/* eslint-disable prettier/prettier */
import { useRef, useState, useEffect } from 'react';
import { MoreVertical, RotateCw, XCircle } from 'lucide-react';

export const InvitationRow = ({
  invitation,
  isSuperAdmin,
  onResend,
  onRevoke,
  loadingAction,
}: any) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const buttonRef = useRef<HTMLButtonElement | null>(null);

  const formatRoleName = (roleName: string) => {
    if (!roleName) return '';
    return roleName
      .trim()
      .replace(/_/g, ' ')
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="cursor-pointer sm:w-[90%] flex items-center px-4 py-3 bg-white border-b border-x hover:bg-light">
      <div className={`${isSuperAdmin ? 'w-[25%]' : 'w-[30%]'} text-primary`}>
        {invitation.email}
      </div>
      {isSuperAdmin && (
        <div className="w-[20%] text-muted-foreground">{invitation.company?.name || ''}</div>
      )}
      <div className="w-[20%] text-muted-foreground">{formatRoleName(invitation.role?.name)}</div>
      <div className={`${isSuperAdmin ? 'w-[20%]' : 'w-[25%]'} text-muted-foreground`}>
        {invitation.createdBy?.email || 'N/A'}
      </div>
      <div className={`${isSuperAdmin ? 'w-[10%]' : 'w-[20%]'} text-muted-foreground`}>
        <span
          className={`px-2 py-1 text-sm rounded-full font-medium ${
            invitation.status === 'accepted'
              ? 'bg-green-100 text-green-700 border'
              : invitation.status === 'revoked'
              ? 'bg-red-100 text-red-700 border'
              : invitation.status === 'expired'
              ? 'bg-yellow-100 text-yellow-800 border'
              : 'bg-blue-100 text-blue-700 border'
          }`}
        >
          {invitation.status.charAt(0).toUpperCase() + invitation.status.slice(1)}
        </span>
      </div>

      {invitation.status !== 'accepted' && (
        <div className="w-[5%] flex justify-end relative">
          <button ref={buttonRef} onClick={() => setIsOpen(!isOpen)}>
            <MoreVertical className="w-5 h-5 text-muted-foreground" />
          </button>
          {isOpen && (
  <div
    ref={dropdownRef}
    className="absolute right-0 z-10 w-40 mt-2 bg-white border rounded shadow-md"
  >
    {loadingAction === 'resend' && (
      <button
        disabled
        className="flex items-center w-full gap-2 px-4 py-2 text-sm opacity-50 cursor-not-allowed"
      >
        Resending...
      </button>
    )}

    {loadingAction === 'revoke' && (
      <button
        disabled
        className="flex items-center w-full gap-2 px-4 py-2 text-sm opacity-50 cursor-not-allowed"
      >
        Revoking...
      </button>
    )}

    {!loadingAction && (
      <>
        <button
          onClick={async () => {
            await onResend();
            setIsOpen(false);
          }}
          className="flex items-center w-full gap-2 px-4 py-2 text-sm hover:bg-highlight"
        >
          <RotateCw className="w-4 h-4" /> Resend
        </button>

        {invitation.status !== 'revoked' && invitation.status !== 'expired' && (
          <button
            onClick={async () => {
              await onRevoke();
              setIsOpen(false);
            }}
            className="flex items-center w-full gap-2 px-4 py-2 text-sm text-red-600 hover:bg-highlight"
          >
            <XCircle className="w-4 h-4" /> Revoke
          </button>
        )}
      </>
    )}
  </div>
)}

        </div>
      )}
    </div>
  );
};
